import { render, staticRenderFns } from "./BarChartSimple.vue?vue&type=template&id=6b1cffb7&scoped=true&"
import script from "./BarChartSimple.vue?vue&type=script&lang=js&"
export * from "./BarChartSimple.vue?vue&type=script&lang=js&"
import style0 from "./BarChartSimple.vue?vue&type=style&index=0&id=6b1cffb7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b1cffb7",
  null
  
)

export default component.exports